// extracted by mini-css-extract-plugin
module.exports = {"waitMessage":"GameBoard_waitMessage__20C4a","deck":"GameBoard_deck__2XtAV","hasHighlight":"GameBoard_hasHighlight__1ZqzC","highlight":"GameBoard_highlight__234sR"};